import React, {
    useState,
    useEffect,
    useContext,
    Fragment,
    useCallback,
  } from 'react';
  import Layout from 'components/sales/layout/layout';
  import localization from 'assets/localization/localization';
  import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
  import { Button, Table } from 'react-bootstrap';
  import Images from 'assets/images/imageData';
  import ModalPop from 'components/sales/modal/modal';
  import { Link } from 'react-router-dom';
  import { BaseUrl } from 'contexts/baseUrl/baseUrl';
  import DocumentView from 'components/sales/downloadDocView/documentView';
  import DivLayout from 'components/sales/divLayout/divLayout';
  import moment from 'moment';
  
  const CarnivalDetails = ({
    getCarnivalDetail,
    carnivalDetail,
    match,
    history,
  }) => {
    const [details, setDetails] = useState(null);
    const { baseUrl } = useContext(BaseUrl);
    const [isModal, setIsModal] = useState(false);
    const [isStatusModal, setIsStatusModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isCancelModal, setIsCancelModal] = useState(false);
    const [isCompleteModal, setIsCompleteModal] = useState(false);
  
    const getMeeting = useCallback(async () => {
      if (match?.params?.id) {
        setIsLoading(true);
        await getCarnivalDetail(match?.params?.id);
        setIsLoading(false);
      }
    }, [getCarnivalDetail, match?.params?.id]);
  
    useEffect(() => {
      getMeeting();
    }, [getMeeting]);
  
    useEffect(() => {
      if (carnivalDetail) {
        setDetails(carnivalDetail);
      }
    }, [carnivalDetail]);
  
    
    return (
      <Layout
        title={localization.carnivalDetails}
        isGoback
        isLoading={isLoading}
        linkFlag
        linkUrl={`${baseUrl}/brand-activation/conduct-site-carnival/carnival/${details?.carnival?.site_id}`}
      >
        {details && details.carnival && Object.keys(details?.carnival).length !== 0 ? (
          <div className="panel-card">
            <div className="panel-heading">{localization.carnivalDetails}</div>
            <div className="panel-body">
              <div className="details-listing">
                <DivLayout
                  heading={localization.projectId}
                  data={
                    details?.carnival?.infra_id
                      ? details?.carnival?.infra_id
                      : ''
                  }
                />
                <DivLayout
                  heading={localization.carnivalLink}
                  data={
                    (details?.carnival?.carnival_url && details?.carnival.status ==1)
                    ? <a href={details?.carnival?.carnival_url} target="_blank">Click Here</a> 
                    : ''
                  }
                />
                <DivLayout
                  heading={localization.qrLink}
                  data={
                    (details?.carnival?.qr_link && details?.carnival.status ==1)
                    ? <a href={details?.carnival?.qr_link} target="_blank">Click Here</a> 
                    : ''
                  }
                />
                <DivLayout
                  heading={localization.carnivalName}
                  data={
                    details?.carnival?.name
                      ? details?.carnival?.name
                      : ''
                  }
                />
                <DivLayout
                  heading={localization.startDate}
                  data={
                    details?.carnival?.start_date
                      ? details?.carnival?.start_date
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.startTime}
                  data={
                    details?.carnival?.start_time
                      ? details?.carnival?.start_time
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.endDate}
                  data={
                    details?.carnival?.end_date
                      ? details?.carnival?.end_date
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.endTime}
                  data={
                    details?.carnival?.end_time
                      ? details?.carnival?.end_time
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.status}
                  data={
                    details?.carnival?.status_name
                      ? details?.carnival?.status_name
                      : localization.na
                  }
                />
                <DivLayout
                  heading={'Carnival type'}
                  data={
                    details?.carnival?.carnival_type
                      ? details?.carnival?.carnival_type
                      : localization.na
                  }
                />
                <DivLayout
                  heading={'GST Number'}
                  data={
                    details?.carnival?.gst_number
                      ? details?.carnival?.gst_number
                      : localization.na
                  }
                />
                <DivLayout
                  heading={'Photo of the place'}
                  data={
                    details?.carnival?.event_photo ? (
                      <a href={details.carnival.event_photo} target="_blank" rel="noopener noreferrer">
                        View Photo
                      </a>
                    ) : (
                      localization.na
                    )
                  }
                />
                <DivLayout
                  heading={'Cancelled Cheque'}
                  data={
                    details?.carnival?.cancelled_cheque ? (
                      <a href={details.carnival.cancelled_cheque} target="_blank" rel="noopener noreferrer">
                        View Cancelled Cheque
                      </a>
                    ) : (
                      localization.na
                    )
                  }
                />
              </div>
            </div>
          </div>
        ) : null}
        {details &&
          details?.carnival?.services &&
          Object.keys(details?.carnival.services).length !== 0 && (
            <div className="panel-card">
              <div className="panel-heading">{localization.services}</div>
              <div className="panel-body">
                <div className="details-list">
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>Service</th>
                        <th>Promo Code</th>
                        <th>Promo Ids</th>
                      </tr>
                    </thead>
                    <tbody>
                      {details &&
                        details?.carnival.services &&
                        details?.carnival.services.map((val) => {
                          return (
                            <tr>
                              <td>{val.name}</td>
                              <td>{val.price}</td>
                              <td>{val.camp_id}</td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          )}
  
        {details &&
        details?.carnival?.members &&
        Object.keys(details?.carnival?.members).length !== 0 ? (
          <div className="panel-card">
            <div className="panel-heading">{localization.memberDetails}</div>
            <div className="panel-body">
                <div className="details-listing faq-listing">
                <Table striped bordered hover>
                    
                      { (details?.carnival.members &&
                        details?.carnival.member_exists == 1) ?
                        <>
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Designation</th>
                            <th>Image</th>
                          </tr>
                        </thead>
                        <tbody>
                        {details?.carnival.members.map((val) => {
                          <>
                          return (
                            <tr>
                                <td>{val.name}</td>
                                <td>{val.position}</td>
                                <td>
                                    <DocumentView
                                    title={val.name}
                                    attachment={val.image_url}
                                    />
                                </td>
                            </tr>
                          );
                          </>
                        })}
                        </tbody> 
                        </>
                        :
                        <>
                        <thead>
                          <tr>
                            <th>Carnival Image</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                          <td>
                                    <DocumentView
                                    title={'image'}
                                    attachment={details?.carnival.members}
                                    />
                                </td>
                          </tr>
                        </tbody>
                        </>
                        }
                  </Table>
                </div>
            </div>
          </div>
        ) : null}

        {details && details.carnival && Object.keys(details?.carnival).length !== 0 ? (
        <>
        <div className="panel-card">
            <div className="panel-heading">{'Event Details'}</div>
            <div className="panel-body">
              <div className="details-listing">
                <DivLayout
                  heading={'Event Status'}
                  data={
                    details?.carnival?.event_details?.event_status
                      ? details?.carnival?.event_details?.event_status
                      : ''
                  }
                />
                <DivLayout
                  heading={'Total footfall'}
                  data={
                    (details?.carnival?.event_details?.total_footfall)
                    ? details?.carnival?.event_details?.total_footfall
                    : ''
                  }
                />
                <DivLayout
                  heading={'Total Tags Issued'}
                  data={
                    (details?.carnival?.event_details?.total_tags_issued)
                    ? details?.carnival?.event_details?.total_tags_issued
                    : ''
                  }
                />
                <DivLayout
                  heading={'Manpower required'}
                  data={
                    details?.carnival?.event_details?.manpower_required
                      ? details?.carnival?.event_details?.manpower_required
                      : ''
                  }
                />
                <DivLayout
                  heading={'Partner allowed'}
                  data={
                    details?.carnival?.event_details?.partner_allowed
                      ? details?.carnival?.event_details?.partner_allowed
                      : localization.na
                  }
                />
                <DivLayout
                  heading={'Location'}
                  data={
                    details?.carnival?.event_details?.location
                      ? details?.carnival?.event_details?.location
                      : localization.na
                  }
                />
                <DivLayout
                  heading={'Latitude'}
                  data={
                    details?.carnival?.event_details?.lat
                      ? details?.carnival?.event_details?.lat
                      : localization.na
                  }
                />
                <DivLayout
                  heading={'Longitude'}
                  data={
                    details?.carnival?.event_details?.lng
                      ? details?.carnival?.event_details?.lng
                      : localization.na
                  }
                />
                <DivLayout
                  heading={'Remarks'}
                  data={
                    details?.carnival?.event_details?.remarks
                      ? details?.carnival?.event_details?.remarks
                      : localization.na
                  }
                />
              </div>
            </div>
        </div>

        <div className="panel-card">
            <div className="panel-heading">{'Bank Details'}</div>
            <div className="panel-body">
              <div className="details-listing">
                <DivLayout
                  heading={'Bank Name'}
                  data={
                    (details?.carnival?.bank_details?.bank_name)
                      ? details?.carnival?.bank_details?.bank_name
                      : ''
                  }
                />
                <DivLayout
                  heading={'Bank Branch'}
                  data={
                    (details?.carnival?.bank_details?.branch_name)
                    ? details?.carnival?.bank_details?.branch_name
                    : ''
                  }
                />
                <DivLayout
                  heading={'IFSC Code'}
                  data={
                    (details?.carnival?.bank_details?.ifsc_code)
                    ? details?.carnival?.bank_details?.ifsc_code
                    : ''
                  }
                />
                <DivLayout
                  heading={'Account Number'}
                  data={
                    (details?.carnival?.bank_details?.act_number)
                      ? details?.carnival?.bank_details?.act_number
                      : ''
                  }
                />
              </div>
            </div>
        </div>

      {details &&
        Array.isArray(details?.carnival?.partner_details) &&
        details.carnival.partner_details.length !== 0 && (
          <div className="panel-card">
            <div className="panel-heading">Partner Details</div>
            <div className="panel-body">
            <div className="flex flex-wrap gap-6 mb-4 mr-4">
                {details.carnival.partner_details.map((partner, index) => (
                  <div
                    key={index}
                    className="details-listing border p-4 rounded-md basis-1/3"
                  >
                    <DivLayout
                      heading={'Name of Company'}
                      data={partner.companyName || ''}
                    />
                    <DivLayout
                      heading={'Cost of the partner'}
                      data={partner.cost || ''}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        </>
        ) : null}
      </Layout>
    );
  };
  
  export default CarnivalDetails;
  